import estilos from './servicios/InformacionI.module.css'
import './servicios/InformacionI.module.css';

function InformacionI({children, children2, titulo, informacion, vinculo, infov}) {
    return (
      <> 
      <h2 className={estilos.h2}>
          {titulo}
      </h2>
      <hr className={estilos.hr} />
      <div className={estilos.div}>
        <div className={estilos.aside}>
          <aside> 
            {informacion}
            <a className={`${estilos.a} ${vinculo === "/Service/2" ? 'bg-primary' : ''}`} href={vinculo}>{infov}</a>
          </aside>
        </div>
        <div className={estilos.img}>
          <img  src={children} alt={children2} />
        </div>
      </div>
      </>
    );
  };
  
  export default InformacionI;